const TheWikiCemeteryPage = () =>
  import('@/views/wiki/cemetery/view/TheWikiCemeteryPage.vue')

export default [
  {
    path: 'cemetery',
    name: 'wiki_cemetery_page_route',
    component: TheWikiCemeteryPage
  }
]
